/* eslint-disable global-require */
module.exports = ['artistes', 'oeuvres', 'search.index.m9', 'search.universal.header.m4'];
